var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { pages, url } from "@recoil/Store";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import * as Const from "@utils/Const";
import * as cutil from "@utils/Cutil";
import { useAsync } from "react-async";
import { PromiseHttp } from "@utils/api/HttpUtil";
import { useEffect } from "react";
import Main from "../../Main";
import dayjs from "dayjs";
import Popup from "@components/common/Popup";
import Pagenation from "@components/common/Pagenation";
export default function ContactEn(props) {
    const [urls, setUrl] = useRecoilState(url);
    return (_jsxs(_Fragment, { children: [_jsx("style", { children: `
    .contact-list {
      list-style: none;
      padding: 0;
      margin: 0;
      border-top: 1px solid #ddd;
    }

    .contact-list li {
      padding: 16px 12px;
      border-bottom: 1px solid #ddd;
      display: flex;
      flex-direction: column;
      transition: 0.2s;
    }

    .contact-list li:hover {
      background: #f9f9f9;
    }


    .contact-header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 12px;
    }

    .contact-title {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      font-size: 16px;
      font-weight: 500;
      color: #272727;
      gap: 8px;
      flex: 1;
      min-width: 0;
      word-break: break-all;
    }

    .contact-title svg {
      flex-shrink: 0;
    }

    .contact-status {
      font-size: 14px;
      color: #777;
    }



    /*'답변완료' */
    .answer-status {
      font-size: 14px;
      font-weight: 500;
      color: #008000;
      background: #e9f6eb;
      padding: 4px 10px;
      border-radius: 12px;
      white-space: nowrap;
      flex-shrink: 0;
    }

    /* '답변대기' */
    .answer-status2 {
      font-size: 14px;
      font-weight: 500;
      color: #a30000;
      background: #f6e9e9;
      padding: 4px 10px;
      border-radius: 12px;
      white-space: nowrap;
      flex-shrink: 0;
    }

    .contact-meta {
      display: flex;
      gap: 12px;
      margin-top: 6px;
      font-size: 14px;
      color: #777;
    }

    .contact-meta span {
      white-space: nowrap;
    }

    /* 반응형 */
    @media (max-width: 600px) {
      .contact-header {
        align-items: flex-start;
        gap: 6px;
      }

      .answer-status {
        align-self: flex-end;
        /* ✅ 모바일에서 오른쪽 유지 */
        font-size: 13px;
        padding: 3px 8px;
      }

      .answer-status2 {
        align-self: flex-end;
        /* ✅ 모바일에서 오른쪽 유지 */
        font-size: 13px;
        padding: 3px 8px;
      }

      .contact-title {
        font-size: 14px;
      }

      .contact-meta {
        align-items: flex-start;
        gap: 4px;
        font-size: 13px;
      }
    }

    .contact-meta span {
      white-space: nowrap;
    }

    /* 오른쪽 '답변완료' 표시 */
    .answer-status {
      font-size: 14px;
      font-weight: 500;
      color: #008000;
      /* 초록색 */
      background: #e9f6eb;
      padding: 4px 10px;
      border-radius: 12px;
      white-space: nowrap;
    }

    /* 반응형 */
    @media (max-width: 600px) {
      .contact-list li {
        padding: 12px 8px;
      }

      .contact-title {
        font-size: 14px;
        flex-wrap: wrap;
      }

      .contact-status {
        margin-left: 4px;
        font-size: 13px;
      }

      .contact-meta {
        flex-direction: column;
        gap: 4px;
        font-size: 13px;
      }
        
    }
      ` }), _jsx(Main, {}), (urls) &&
                _jsx(View, { url: urls, setUrl: setUrl })] }));
}
function View(props) {
    const { url, setUrl } = props;
    const location = useLocation();
    const navigate = useNavigate();
    let pageInfo = useRecoilValue(pages);
    const [page, setPage] = useState(pageInfo);
    const [list, setList] = useState([]);
    const [items, setItems] = useState(null);
    const [search, setSearh] = useState("");
    const [searchApi, setSearhApi] = useState("");
    let boardType = url.depth2.menuName;
    function handlePage(pages) {
        setPage(Object.assign(Object.assign({}, page), { pageNum: pages - 1 }));
    }
    const lang = localStorage.getItem(Const.LANG_TYPE);
    let appPath = `?page=${page.pageNum}&size=${page.size}`;
    if (searchApi.length > 0)
        appPath = appPath + `&search=${searchApi}`;
    // API
    const { data: data } = useAsync({
        promiseFn: PromiseHttp,
        httpMethod: Const.API_GET,
        appPath: `/open/board/${boardType}/detail?lang=ENG`,
        appQuery: {},
        userToken: "",
        watch: appPath + lang,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == Const.API_200) {
                List(data.body);
            }
        }
    }, [data]);
    const List = (board) => __awaiter(this, void 0, void 0, function* () {
        let data = null;
        data = yield PromiseHttp({
            httpMethod: Const.API_GET,
            appPath: `/open/board/${board.boardId}/list${appPath}`,
            appQuery: {},
            userToken: "",
        });
        if (data) {
            if (data.codeNum == Const.API_200) {
                sessionStorage.setItem("boardId", board.boardId);
                setList(data.body);
                setPage(Object.assign(Object.assign({}, data.data.page), { totalPages: Math.ceil(data.data.page.totalElements / page.size) }));
            }
            else {
            }
        }
    });
    //엔터검색
    function Search(e) {
        if (e.key == "Enter") {
            setSearhApi(e.target.value);
            handlePage(0);
        }
    }
    const Detail = (e, item, id) => {
        setItems(item);
        cutil.popupOpen(id);
        // cutil.handleUrl(e, url.depth1, url.depth2, navigate, setUrl, { mode: Const.URL_DETAIL, id: item.postId })
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "notice-section" }, { children: [_jsxs("div", Object.assign({ className: "notice-header" }, { children: [_jsx("h2", { children: "Inquiries" }), _jsxs("div", Object.assign({ className: "search-box" }, { children: [_jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" }, { children: _jsx("path", { d: "M20 18.278L14.2739 12.5519C15.3325 10.943 15.7565 8.9986 15.4638 7.09509C15.1711 5.19158 14.1825 3.46437 12.6894 2.24789C11.1964 1.0314 9.3051 0.412159 7.3817 0.510063C5.45831 0.607966 3.63966 1.41605 2.27785 2.77785C0.916047 4.13966 0.107966 5.95831 0.0100628 7.8817C-0.0878409 9.8051 0.531397 11.6964 1.74789 13.1894C2.96437 14.6825 4.69158 15.6711 6.59509 15.9638C8.4986 16.2565 10.443 15.8325 12.0519 14.7739L17.778 20.5L20 18.278ZM2.22389 8.27892C2.22389 5.21588 4.71588 2.72389 7.77892 2.72389C10.842 2.72389 13.334 5.21588 13.334 8.27892C13.334 11.342 10.842 13.834 7.77892 13.834C4.71588 13.834 2.22389 11.342 2.22389 8.27892Z", fill: "#666666" }) })), _jsx("input", { type: "text", placeholder: "Enter search term", value: search, onChange: (e => setSearh(e.target.value)), onKeyDown: (e) => Search(e) })] }))] })), _jsx("ul", Object.assign({ className: "contact-list" }, { children: list && list.map((item) => (_jsxs("li", Object.assign({ onClick: (e) => Detail(e, item, Const.POPID) }, { children: [_jsxs("div", Object.assign({ className: "contact-header" }, { children: [_jsxs("span", Object.assign({ className: "contact-title" }, { children: [_jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" }, { children: _jsx("path", { d: "M11.9993 5.33366H11.3327V4.00033C11.3327 2.16033 9.83935 0.666992 7.99935 0.666992C6.15935 0.666992 4.66602 2.16033 4.66602 4.00033V5.33366H3.99935C3.26602 5.33366 2.66602 5.93366 2.66602 6.66699V13.3337C2.66602 14.067 3.26602 14.667 3.99935 14.667H11.9993C12.7327 14.667 13.3327 14.067 13.3327 13.3337V6.66699C13.3327 5.93366 12.7327 5.33366 11.9993 5.33366ZM5.99935 4.00033C5.99935 2.89366 6.89268 2.00033 7.99935 2.00033C9.10602 2.00033 9.99935 2.89366 9.99935 4.00033V5.33366H5.99935V4.00033ZM11.9993 13.3337H3.99935V6.66699H11.9993V13.3337ZM7.99935 11.3337C8.73268 11.3337 9.33268 10.7337 9.33268 10.0003C9.33268 9.26699 8.73268 8.66699 7.99935 8.66699C7.26602 8.66699 6.66602 9.26699 6.66602 10.0003C6.66602 10.7337 7.26602 11.3337 7.99935 11.3337Z", fill: "#272727" }) })), item.title, _jsx("span", Object.assign({ className: "contact-status" }, { children: item.hasReply ? "[1]" : "" }))] })), _jsx("span", Object.assign({ className: `${item.hasReply ? "answer-status" : "answer-status2"}` }, { children: item.hasReply ? "Answered" : "Pending" }))] })), _jsxs("div", Object.assign({ className: "contact-meta" }, { children: [_jsxs("span", { children: ["Author : ", item.writer ? item.writer : "-"] }), _jsx("span", { children: dayjs(item.createdAt).format("YYYY/MM/DD") })] }))] }), item.postId))) })), _jsx("div", Object.assign({ className: "contact-button", onClick: (e) => cutil.handleUrl(e, url.depth1, url.depth2, navigate, setUrl, { mode: Const.URL_WRITE }) }, { children: _jsx("button", Object.assign({ className: "contact" }, { children: "Write Inquiry" })) })), _jsx(Pagenation, { page: page, handlePage: handlePage })] })), _jsx(Popup, { item: items, urls: url, lang: "lang" })] }));
}
